"use client";

import { CommentsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedCommentsSection from "../Components/GeneratedCommentsSection";

const Comments: FC<CommentsSectionProps> = (props) => {
  return <GeneratedCommentsSection {...props} />;
};

export default Comments;
